<template>
  <table aria-labelledby="table-heading-act">
		<caption id="table-heading-act">ACT composite score, 5 year average</caption>
		<thead>
			<tr>
				<th>{{ s1Name }}</th>
				<th>{{ s2Name }}</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>{{ s1Data.isNull ? NA : s1.data.actScores.avg_score }}</td>
				<td>{{ s2Data.isNull ? NA : s2Data.avg }}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	export default {
		props: ['s1Name', 's2Name', 's1Data', 's2Data'],
		data() {
			return {
				NA: 'data point unavailable'
			}
		}
	}
</script>
